import React, { useState, useEffect } from 'react';
import SelectorModal from './SelectorModal';

const LendingModal = ({ isOpen, onClose, onSave, loading, friends }) => {
  const [itemName, setItemName] = useState('');
  const [personName, setPersonName] = useState('');
  const [type, setType] = useState('lent');
  const [lentOn, setLentOn] = useState(new Date().toISOString().split('T')[0]);
  const [formError, setFormError] = useState(null);
  const [isPersonSelectorOpen, setIsPersonSelectorOpen] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setItemName('');
      setPersonName('');
      setType('lent');
      setLentOn(new Date().toISOString().split('T')[0]);
      setFormError(null);
      setIsPersonSelectorOpen(false);
    }
  }, [isOpen]);

  const handleSubmit = (event) => {
    event.preventDefault();
    setFormError(null);

    if (!itemName.trim() || !personName.trim()) {
      setFormError('กรุณากรอกข้อมูลให้ครบถ้วน');
      return;
    }

    onSave({
      itemName: itemName.trim(),
      personName: personName.trim(),
      type,
      lentOn
    });
  };

  if (!isOpen) return null;

  return (
    <div
      style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'flex-end' }}
      onClick={onClose}
    >
      <style>
        {`@keyframes slideUp { from { transform: translateY(100%); } to { transform: translateY(0); } }`}
      </style>
      <div
        style={{ backgroundColor: 'white', width: '100%', borderRadius: '20px 20px 0 0', padding: '25px', height: '85vh', overflowY: 'auto', animation: 'slideUp 0.3s ease-out', boxShadow: '0 -4px 20px rgba(0,0,0,0.1)' }}
        onClick={(event) => event.stopPropagation()}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <h2 style={{ color: 'var(--color-primary)', margin: 0, fontSize: '24px' }}>บันทึกยืม-คืนของ</h2>
          <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer', color: 'var(--color-text-subtle)' }}>&times;</button>
        </div>

        <form onSubmit={handleSubmit}>
          {formError && <div style={{ color: '#d32f2f', marginBottom: '20px', padding: '12px', backgroundColor: '#ffebee', borderRadius: '8px', fontSize: '14px' }}>{formError}</div>}

          <div style={{ marginBottom: '15px' }}>
            <label style={{ display: 'block', marginBottom: '5px', color: 'var(--color-text-muted)' }}>ประเภท</label>
            <select value={type} onChange={event => setType(event.target.value)} style={{ width: '100%', padding: '12px', borderRadius: '8px', border: '1px solid var(--color-border)', fontSize: '16px', backgroundColor: '#fff' }}>
              <option value="lent">คนอื่นยืม</option>
              <option value="borrowed">ฉันยืมมา</option>
            </select>
          </div>
          <div style={{ marginBottom: '15px' }}>
            <label style={{ display: 'block', marginBottom: '5px', color: 'var(--color-text-muted)' }}>ชื่อสิ่งของ</label>
            <input type="text" value={itemName} onChange={event => setItemName(event.target.value)} placeholder="เช่น หนังสือ, Power Bank" style={{ width: '100%', padding: '12px', borderRadius: '8px', border: '1px solid var(--color-border)', fontSize: '16px', boxSizing: 'border-box' }} />
          </div>
          <div style={{ marginBottom: '15px' }}>
            <label style={{ display: 'block', marginBottom: '5px', color: 'var(--color-text-muted)' }}>{type === 'lent' ? 'ใครยืมไป' : 'ยืมมาจากใคร'}</label>
            <div
              onClick={() => setIsPersonSelectorOpen(true)}
              style={{
                width: '100%',
                padding: '12px',
                borderRadius: '8px',
                border: '1px solid var(--color-border)',
                fontSize: '16px',
                boxSizing: 'border-box',
                color: personName ? 'var(--color-text)' : 'var(--color-text-subtle)',
                cursor: 'pointer',
                backgroundColor: '#fff'
              }}
            >
              {personName || 'ค้นหาจากเพื่อน หรือพิมพ์ชื่อใหม่'}
            </div>
          </div>
          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '5px', color: 'var(--color-text-muted)' }}>วันที่</label>
            <input type="date" value={lentOn} onChange={event => setLentOn(event.target.value)} style={{ width: '100%', padding: '12px', borderRadius: '8px', border: '1px solid var(--color-border)', fontSize: '16px', boxSizing: 'border-box' }} />
          </div>
          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%',
              padding: '16px',
              backgroundColor: 'var(--color-primary)', backgroundImage: 'var(--color-primary-gradient)',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              fontSize: '16px',
              fontWeight: 'bold',
              cursor: 'pointer',
              boxShadow: '0 4px 10px rgba(var(--color-primary-rgb), 0.2)',
              transition: 'all 0.2s'
            }}
          >
            {loading ? 'กำลังบันทึก...' : 'บันทึก'}
          </button>
        </form>
      </div>

      {isPersonSelectorOpen && (
        <SelectorModal
          initialValue={personName}
          options={[]}
          friends={friends || []}
          onSelect={(val) => {
            setPersonName(val);
            setIsPersonSelectorOpen(false);
          }}
          onClose={() => setIsPersonSelectorOpen(false)}
        />
      )}
    </div>
  );
};

export default LendingModal;
